
































import axios from 'axios';
import EventBus from '@/eventBus';

import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoShareInMessenger from '../co-share-in-messenger/CoShareInMessenger.vue';

export default {
    name: 'CoShare',
    components: {
        CoRoundButton,
        CoDropdown,
        CoDropdownItem,
        CoShareInMessenger,
    },
    props: {
        title: {
            type: String,
            default: '',
        },

        url: {
            type: String,
            default: '',
        },

        contentID: {
            type: [String, Number],
            default: null,
            required: false,
        },

        contentSlug: {
            type: String,
            default: null,
        },

        text: {
            type: String,
            default: '',
        },
        disableShareInPost: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        shareData() {
            return {
                title: this.title,
                text: this.text,
                url: this.url,
                contentID: this.contentID,
                contentSlug: this.contentSlug,
            };
        },

        isWebShareSupported() {
            return !!navigator.share;
        },
        isLoggedIn() {
            if (this.$store && this.$store.getters) {
                return this.$store.getters.isAuthenticated;
            }
            return false;
        },
        sharedContentType() {
            if (!this.url) {
                return null;
            }

            try {
                const url = new URL(this.url, window.location.origin);
                const firstSegment = (url.pathname.split('/').filter(Boolean)[0] || '').toLowerCase();
                switch (firstSegment) {
                    case 'event':
                    case 'events':
                        return 'event';
                    case 'page':
                    case 'pages':
                    case 'project':
                    case 'projects':
                    case 'channel':
                    case 'channels':
                        return 'page';
                    case 'post':
                        return 'post';
                    case 'job':
                    case 'jobs':
                        return 'job';
                    default:
                        return null;
                }
            } catch (error) {
                return null;
            }
        },
    },
    methods: {
        handleDropdownOpen() {
            // Track share dropdown open to measure share entry intent.
            this.recordActivity('share_activity', 'feature_click', 'share_dropdown_open');
        },
        showShareDialog() {
            // Track user intent to share via native share before invoking the API.
            this.recordActivity('share_activity', 'feature_click', 'share_web_share');
            // user window.navigator.share() to share the content
            if (window.navigator.share) {
                window.navigator
                    .share(this.shareData)
                    .then(() => console.log('Successful share'))
                    .catch((error) => console.log('Error sharing', error));
            } else {
                console.log('WebShare API not supported.');
            }
        },

        async copyLink() {
            try {
                // Track share copy-link action for share funnel analytics.
                this.recordActivity('share_activity', 'feature_click', 'share_copy_link');
                await navigator.clipboard.writeText(this.url);
                EventBus.$emit('INFO', {
                    Message: this.$t('messages.copiedtoclipboard'),
                });
            } catch (err) {
                EventBus.$emit('ERROR', {
                    Message: this.$t('labels.failedGeneric'),
                });
            }
        },
        shareInPost() {
            this.$emit('shareinpost');
        },
        recordActivity(funnel = 'share_activity', step = 'feature_click', feature_key = 'share') {
            const route = this.$route || null;
            const location = route?.path || window.location.pathname;
            const fullPath = route?.fullPath || `${window.location.pathname}${window.location.search}`;

            axios
                .post('/me/activity/funnel', {
                    funnel,
                    step,
                    feature_key,
                    location,
                    full_path: fullPath,
                    parameters: {
                        contentType: this.sharedContentType,
                        contentSlug: this.contentSlug,
                        contentID: this.contentID,
                        contentURl: this.url,
                    },
                })
                .catch((error) => {
                    console.error('Failed to record share activity', error);
                });
        },
    },
};
